import { Link } from "react-router-dom";
import { Phone, Mail, Clock, ShieldCheck } from "lucide-react";
import { SITE } from "@/data/site";
import { SERVICES } from "@/data/services";
import { CITIES } from "@/data/cities";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-brand text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="h-9 w-9 rounded-lg bg-white/15 flex items-center justify-center"><ShieldCheck size={18} /></span>
              <span className="font-display font-bold text-xl">The VIN Verifier CA</span>
            </div>
            <p className="text-white/70 text-sm mt-4 leading-relaxed">
              California DMV-licensed mobile VIN verification serving Orange County and Los Angeles County. We come to you and complete your REG 31 — the first time.
            </p>
            <div className="mt-5 flex flex-col gap-2 text-sm">
              <a href={SITE.phoneHref} className="flex items-center gap-2 hover:text-accent transition-colors"><Phone size={14} /> {SITE.phone}</a>
              <a href={`mailto:${SITE.email}`} className="flex items-center gap-2 hover:text-accent transition-colors"><Mail size={14} /> {SITE.email}</a>
              <span className="flex items-center gap-2 text-white/70"><Clock size={14} /> {SITE.hours}</span>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-white/60 text-xs tracking-widest uppercase mb-4">Services</div>
            <ul className="space-y-2 text-sm">
              {SERVICES.map((s) => (
                <li key={s.slug}><Link to={`/services/${s.slug}`} className="text-white/80 hover:text-accent transition-colors">{s.name}</Link></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-white/60 text-xs tracking-widest uppercase mb-4">Service Areas</div>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
              {CITIES.map((c) => (
                <li key={c.slug}><Link to={`/vin-verification/${c.slug}`} className="text-white/80 hover:text-accent transition-colors">{c.name}</Link></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-white/60 text-xs tracking-widest uppercase mb-4">Company</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-white/80 hover:text-accent transition-colors">Home</Link></li>
              <li><Link to="/free-vin-decoder" className="text-white/80 hover:text-accent transition-colors">Free VIN Decoder</Link></li>
              <li><Link to="/blog" className="text-white/80 hover:text-accent transition-colors">Blog</Link></li>
              <li><Link to="/faq" className="text-white/80 hover:text-accent transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="text-white/80 hover:text-accent transition-colors">Contact</Link></li>
            </ul>
            <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1.5 text-xs">
              <ShieldCheck size={13} className="text-accent" /> Licensed · Verified & Bonded
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/60 text-xs">© {new Date().getFullYear()} The VIN Verifier CA. All rights reserved. · {SITE.license}</p>
          <div className="flex items-center gap-6 text-xs">
            <Link to="/privacy" data-testid="footer-privacy" className="text-white/70 hover:text-accent transition-colors">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms" className="text-white/70 hover:text-accent transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
